/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   BuildingReviewsData Bizo
 */

import camelcaseKeys from 'camelcase-keys'
import type {
  BuildingReviewsData as BuildingReviewsDataType,
  RawBuildingReviewsData,
} from './buildingReviews.types'

export const BuildingReviewsData = {
  fromJS: (data: RawBuildingReviewsData): BuildingReviewsDataType => {
    return camelcaseKeys(data, {
      deep: true,
    })
  },
}

export type BuildingReviewsData = BuildingReviewsDataType
